<template>
    <div class="page">
        <div class="box">
    <div class="organizationBox">
      <div style="color: #666666;"></div>
      <div
        class="mainCard"
        v-if="
          company == null && systemCompanyUser == null && systemCompany == null
        "
      >
        <div class="mainCardLeft">
          <h2>账号认证</h2>
          <span>中人为中小企业提供更全面的服务快来进行认证吧</span>
          <div style="margin-top: 120px;color: #f5a14a;cursor: pointer;">
            <span style="margin-right: 30px;" @click="clickFn('jrzz')"
              >加入组织</span
            >
            <span @click="clickFn('qyrz')">进行个人或组织认证</span>
          </div>
        </div>
        <div class="mainCardRight" style="display: flex;align-items: center;">
            <img src="../../../src/assets/new/logo/autobg2.png" alt="" style="width: 200px;height: 147px;"/>
        </div>
      </div>
      <!-- 加入企业审核进度盒子 -->
      <div
        class="mainCard1"
        v-else-if="company == null && systemCompanyUser != null"
      >
        <div class="mainCardTopBox">
          <div class="mainCardTopLeftBox">
            <div style="display: flex;align-items: center;margin-bottom: 20px;">
              <div style="font-size: 20px;margin-right: 10px;">
                {{ revieCompany.companyName }}
              </div>
              <div style="display: flex;align-items: center;">
                <img
                  src="../../../src/assets/new/logo/successImg.png"
                  alt=""
                  style="width: 30px;height: 30px;"
                />
                <img src="" alt="" />
                <span style="color: #03b615;">已认证</span>
              </div>
            </div>
            <div style="display: flex;align-items: center;">
              <div
                style="width: 90px;height: 25px;background-color: #fcdfba;border-radius: 20px;text-align: center;line-height: 25px;color: #f59c28;margin-right: 30px;"
              >
                {{ revieCompany.companyType == 1 ? "企业" : "个体工商户" }}
              </div>
              <span style="margin-right: 30px;color: #968e84;"
                >管理员：&nbsp;{{ revieCompany.userName }}</span
              >
              <span style="color: #968e84;"
                >认证时间：&nbsp;{{
                  revieCompany.createTime | timestampToTime
                }}</span
              >
            </div>
          </div>
          <div class="mainCardTopRightBox" style="display: none;">
            <div style="display: flex;align-items: center;">
              <img
                src="../../../src/assets/new/logo/successImg.png"
                alt=""
                style="width: 30px;height: 30px;"
              />
              <span style="color: #ea813b;">{{
                revieCompany.companyName
              }}</span>
            </div>
          </div>
        </div>
        <div class="bottomStep">
          <el-steps
            :active="
              systemCompanyUser == null && systemCompanyUser3 != null ? 3 : 2
            "
            align-center
          >
            <el-step title="提交申请" description="已提交"></el-step>
            <el-step title="管理员审核" description="已提交"></el-step>
            <el-step
              :title="
                systemCompanyUser == null && systemCompanyUser3 != null
                  ? '加入失败'
                  : '加入组织'
              "
              :description="
                systemCompanyUser == null && systemCompanyUser3 != null
                  ? '审批不通过'
                  : '加入成功'
              "
            ></el-step>
          </el-steps>
          <div
            style="margin-top: 20px;color: #f5a14a;cursor: pointer;"
            v-if="systemCompanyUser == null && systemCompanyUser3 != null"
          >
            <span style="margin-right: 30px;" @click="clickFn('jrzz')"
              >加入组织</span
            >
            <span @click="clickFn('qyrz')">进行个人或组织认证</span>
          </div>
        </div>
      </div>
      <!-- 创建组织审核进度盒子 -->
      <div
        class="mainCard1"
        v-else-if="
          company == null && systemCompanyUser == null && systemCompany != null
        "
      >
        <div class="mainCardTopBox">
          <div class="mainCardTopLeftBox">
            <div style="display: flex;align-items: center;margin-bottom: 20px;">
              <div style="font-size: 20px;margin-right: 10px;">
                {{ systemCompany.companyName }}
              </div>
              <div style="display: flex;align-items: center;">
                <span style="color: rgb(150, 142, 132);">{{
                  systemCompany.companyStatus == 3 ? "已提交" : "审核中"
                }}</span>
              </div>
            </div>
            <div style="display: flex;">
              <div
                style="width: 90px;height: 25px;background-color: #fcdfba;border-radius: 20px;text-align: center;line-height: 25px;color: #f59c28;margin-right: 30px;"
              >
                {{ systemCompany.companyType == 1 ? "企业" : "个体工商户" }}
              </div>
              <span style="margin-right: 30px;color: #968e84;"
                >管理员：&nbsp;{{ systemCompany.userName }}</span
              >
              <span style="color: #968e84;"
                >认证时间：&nbsp;{{
                  systemCompany.createTime | timestampToTime
                }}</span
              >
            </div>
          </div>
          <div class="mainCardTopRightBox" style="display: none;">
            <div style="display: flex;align-items: center;">
              <img
                src="../../../src/assets/new/logo/successImg.png"
                alt=""
                style="width: 30px;height: 30px;"
              />
              <span style="color: #ea813b;">{{
                systemCompany.companyName
              }}</span>
            </div>
          </div>
        </div>
        <div class="bottomStep">
          <el-steps
            :active="systemCompany.companyStatus == 2 ? 2 : 3"
            align-center
          >
            <el-step title="提交申请" description=""></el-step>
            <el-step
              title="管理员审核"
              :description="
                systemCompany.companyStatus == 3 ? '已提交' : '审核中'
              "
            ></el-step>
            <el-step
              :title="
                systemCompany.companyStatus == 3 ? '加入失败' : '创建组织'
              "
              :description="
                systemCompany.companyStatus == 3 ? '审批不通过' : '认证成功'
              "
              class="endClass"
            ></el-step>
          </el-steps>
          <div
            style="margin-top: 20px;color: #f5a14a;cursor: pointer;"
            v-if="systemCompany.companyStatus == 3"
          >
            <span style="margin-right: 30px;" @click="clickFn('jrzz')"
              >加入组织</span
            >
            <span @click="clickFn('qyrz')">进行个人或组织认证</span>
          </div>
        </div>
      </div>
      <!-- 成功加入企业 -->
      <div class="mainCard2" v-else>
        <div class="mainCardTopBox">
          <div class="mainCardTopLeftBox" style="    font-size: 12px;">
            <div style="display: flex;align-items: center;margin-bottom: 20px;">
              <div style="font-size: 20px;margin-right: 10px;">
                {{ company.companyName }}
              </div>
              <div style="display: flex;align-items: center;">
                <img
                  src="../../../src/assets/new/logo/successImg.png"
                  alt=""
                  style="width: 30px;height: 30px;"
                />
                <img src="" alt="" />
                <span style="color: #03b615;">已认证</span>
              </div>
              <div
                v-if="suState == '0'"
                @click="supprenCheck(company.companyId)"
                style="width: 90px;height: 25px;background-color: #fcdfba;border-radius: 20px;text-align: center;line-height: 25px;color: #f59c28;margin-left: 20px;cursor: pointer;display: none;"
              >
                合作伙伴>>
              </div>
            </div>
            <div style="display: flex;">
              <div
                style="width: 90px;height: 25px;background-color: #fcdfba;border-radius: 20px;text-align: center;line-height: 25px;color: #f59c28;margin-right: 30px;"
              >
                {{ company.userType == 1 ? "企业" : "个体工商户" }}
              </div>
              <span style="margin-right: 30px;color: #968e84;"
                >管理员：&nbsp;{{ company.userName }}</span
              >
              <span style="color: #968e84;"
                >认证时间：&nbsp;{{ user.createTime | timestampToTime }}</span
              >
            </div>
          </div>
          <div class="mainCardTopRightBox" style="display: none;">
            <div style="display: flex;align-items: center;">
              <img
                src="../../../src/assets/new/logo/successImg.png"
                alt=""
                style="width: 30px;height: 30px;"
              />
              <span style="color: #ea813b;">{{ company.companyName }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="organizationBox1" v-if="company != null">
      <h1>组织成员</h1>
      <div class="mainCard3">
        <div>
          <div
            style="display: flex;justify-content: space-between;margin-bottom: 5px;"
          >
            <div style="display: flex;">
              <div
                class="buttonB"
                :class="btnactive == '1' ? 'btnactive' : ''"
                @click="tabActive('1')"
                style="padding: 8px;border-radius: 5px;cursor: pointer;"
              >
                已加入成员
              </div>
              <div
                class="buttonB"
                :class="btnactive == '0' ? 'btnactive' : ''"
                @click="tabActive('0')"
                v-if="company.userId == user.userId"
                style="padding: 8px;border-radius: 5px;cursor: pointer;"
              >
                待审批成员
              </div>
            </div>
          </div>
          <!-- 已加入成员表格 -->
          <div v-if="btnactive == '1'">
            <div v-if="systemCompanyUser0.length === 0" style="text-align: center; padding: 20px; color: #999;">
              暂无已加入成员数据
            </div>
            <el-table
              :data="systemCompanyUser0"
              style="width: 100%"
              height="350"
              v-else
            >
              <el-table-column prop="user.userName" label="姓名" width="180">
              </el-table-column>
              <el-table-column prop="user.userPhone" label="联系方式">
              </el-table-column>
              <el-table-column prop="updateTime" label="加入时间">
                <template slot-scope="scope">
                  <div>{{ scope.row.updateTime | timestampToTime }}</div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="address" label="职位"> </el-table-column>
              <el-table-column prop="address" label="角色"> </el-table-column> -->
              <el-table-column prop="address" label="状态">
                <template slot-scope="scope">
                  <div>{{ scope.row.user.userStatus === '0' ? '已启用' : '已禁用' }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="最近登录时间">
                <template slot-scope="scope">
                  <div>{{ scope.row.user.loginTime | timestampToTime }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="120" v-if="company && company.userId == user.userId">
                <template slot-scope="scope">
                  <el-dropdown v-if="scope.row.userId !== user.userId" @command="handleCommand($event, scope.row)">
                    <el-button size="mini" type="primary">
                      操作<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="edit">修改成员</el-dropdown-item>
                      <el-dropdown-item command="delete">删除成员</el-dropdown-item>
                      <el-dropdown-item command="disable" v-if="scope.row.user.userStatus === '0'">禁用成员</el-dropdown-item>
                      <el-dropdown-item command="enable" v-else>启用成员</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          
          <!-- 待审批成员表格 -->
          <div v-if="btnactive == '0'">
            <div v-if="systemCompanyUser1.length === 0" style="text-align: center; padding: 20px; color: #999;">
              暂无待审批成员数据
            </div>
            <el-table
              :data="systemCompanyUser1"
              style="width: 100%"
              height="350"
              v-else
            >
              <el-table-column prop="user.userName" label="姓名" width="180">
              </el-table-column>
              <el-table-column prop="user.userPhone" label="联系方式">
              </el-table-column>
              <!-- <el-table-column prop="address" label="职位"> </el-table-column>
              <el-table-column prop="address" label="角色"> </el-table-column> -->
              <el-table-column prop="address" label="状态">
                <template slot-scope="scope">
                  <div>待审核</div>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="最近登录时间">
                <template slot-scope="scope">
                  <div>{{ scope.row.user.loginTime | timestampToTime }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="180">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="revie(scope.row.id, '0')"
                    style="background-color: #03b615;color: #fff;"
                    >审核通过</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="revie(scope.row.id, '3')"
                    >拒绝</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <!-- 加入组织弹窗 -->
    <div class="organiztiondialog">
      <el-dialog
        :title="dialogShow == 'jrzz' ? '加入组织' : '创建组织'"
        :visible.sync="dialogVisible"
        width="30%"
        center
        :close-on-press-escape="escape"
        :close-on-click-modal="modal"
      >
        <div class="organizationTop">加入组织 (企业) 后可使用全部功能</div>
        <div class="organizationSub">
          <div class="shu"></div>
          <span class="shuText">申请信息</span>
        </div>
        <div class="organizationName">
          <span class="sqrName">申请人手机号:</span>
          <span class="sqrIphone">{{ name }}</span>
        </div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="83px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="组织名称:"
            prop="name"
            style="display: flex;"
            class="zzmcbox"
          >
            <el-autocomplete
              class="inline-input"
              v-model="ruleForm.name"
              :fetch-suggestions="querySearch"
              placeholder="请输入内容"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <div v-show="dialogShow == 'qyrz'">
            <div class="organizationTop">当前组织 (企业) 暂未加入中人互联</div>
            <div
              style="margin-bottom: 15px;color: black;font-weight: 700;font-size: 15px;text-indent: 1em;"
            >
              完成组织管理员 (首席数字官) 认证需准备:
            </div>
            <div style="margin-bottom: 50px;">
              营业执照、统一社会信用代码证或单位法人证书任一有效证件照片
            </div>
          </div>
          <el-form-item
            style="display: flex;justify-content: center;"
            class="ljcj"
          >
            <el-button
              v-show="dialogShow == 'jrzz'"
              type="primary"
              @click="saveShare()"
              style="margin-right: 100px;"
              >申请加入</el-button
            >
            <el-button
              v-show="dialogShow == 'qyrz'"
              type="primary"
              @click="submitForm()"
              style="margin-right: 100px;"
              >管理员认证</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <!-- 申请成功弹窗 -->
    <div class="organiztiondialog">
      <el-dialog
        title="加入组织"
        :visible.sync="organizationSuccessDialog"
        width="30%"
        center
        :before-close="toW"
        :close-on-press-escape="escape"
        :close-on-click-modal="modal"
      >
        <div
          style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
        >
          <img
            src="../../../src/assets/new/logo/successImg.png"
            alt=""
            style="width: 80px;height: 80px;margin-top: 30px;margin-bottom: 15px;"
          />
          <div style="margin-bottom: 50px;font-size: 16px;">
            申请成功,请等待管理员审批
          </div>
          <div
            style="margin-bottom: 50px;color: #f5b386;font-size: 15px;cursor: pointer;"
            @click="toW"
          >
            查看进度>>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="organiztiondialog">
      <el-dialog
        title="成为组织管理者"
        :visible.sync="organizationSuccessDialogC"
        width="30%"
        center
        :before-close="toW"
        :close-on-press-escape="escape"
        :close-on-click-modal="modal"
      >
        <div
          style="display: flex;flex-direction: column;align-items: center;justify-content: center;"
        >
          <img
            src="../../../src/assets/new/logo/successImg.png"
            alt=""
            style="width: 80px;height: 80px;margin-top: 30px;margin-bottom: 15px;"
          />
          <div style="margin-bottom: 50px;font-size: 16px;">
            提交成功,请等待平台审核
          </div>
          <div
            style="margin-bottom: 50px;color: #f5b386;font-size: 15px;cursor: pointer;"
            @click="toW"
          >
            查看进度>>
          </div>
        </div>
      </el-dialog>
    </div>

    <!-- 成为组织管理员弹窗 -->
    <div class="organiztiondialog">
      <el-dialog
        title="成为组织管理员"
        :visible.sync="qyrzDialog"
        width="30%"
        center
        :close-on-press-escape="escape"
        :close-on-click-modal="modal"
      >
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="企业名称:"
            prop="name"
            class="zzmcbox"
            style="margin-bottom:0px"
            label-width="85px"
          >
            <div
              class="organizationTop1"
              style="margin-bottom:0px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              :title="ruleForm.name"
            >
              {{ ruleForm.name }}
            </div>
          </el-form-item>
          <el-form-item
            label="请选择组织类型:"
            prop="name"
            class="zzmcbox"
            style="display: flex;flex-direction: column;"
          >
            <div style="display: flex;">
              <div
                class="zzTypeBox"
                :class="zzstate ? 'zzactive' : ''"
                @click="togglezzFn('qy')"
              >
                <img
                  src="../../../src/assets/new/logo/successImg.png"
                  alt=""
                  style="width: 30px;height: 30px;"
                />
                <span>企业</span>
              </div>
              <div
                class="zzTypeBox"
                :class="!zzstate ? 'zzactive' : ''"
                @click="togglezzFn('geti')"
              >
                <img
                  src="../../../src/assets/new/logo/successImg.png"
                  alt=""
                  style="width: 30px;height: 30px;"
                />
                <span>企业</span>
                <span>个体工商户</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="上传营业执照:" prop="name" class="zzmcbox">
            <input
              type="file"
              @change="onFileChange0"
              style="display:none"
              ref="selectFiles00"
            />
            <div
              style="vertical-align: middle;width: 148px;height: 148px;border: 1px dashed #c0ccda;font-size: 28px;color: #8c939d;margin-top: 10px;margin-left: 100px;background-color: #fafafa"
            >
              <div
                @click="handleButtonSelected(0)"
                style="margin-top: 43px;text-align: center;line-height: 20px;cursor: pointer;"
                v-if="images0 == null"
              >
                <i class="el-icon-plus"></i><br />
                <span style="font-size: 16px;">上传</span>
              </div>
              <img
                :src="images0"
                width="148px;"
                height="148px"
                style="cursor: pointer;margin-top: -29px;"
                @click="handleButtonSelected(0)"
                v-else
              />
            </div>
            <template>
              <div class="mengcengDiv" style="top: 10px;right: 115px;">
                <img src="../../../src/assets/new/logo/example-img2.210089cb.png" alt="" />
              </div>
            </template>
            <el-dialog :visible.sync="dialogVisibleimg" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
          <el-form-item
            style="display: flex;justify-content: center;"
            class="ljcj"
          >
            <el-button
              type="primary"
              @click="setCompanyAuth()"
              style="margin-right: 100px;"
              :loading="loading"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <!-- 修改成员信息弹窗 -->
    <div class="organiztiondialog">
      <el-dialog
        title="修改成员信息"
        :visible.sync="editMemberDialog"
        width="40%"
      >
        <el-form
          :model="editMemberForm"
          ref="editMemberForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="姓名:" prop="userName">
            <el-input v-model="editMemberForm.userName" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="手机号:" prop="userPhone">
            <el-input v-model="editMemberForm.userPhone" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="邮箱:" prop="userEmail">
            <el-input v-model="editMemberForm.userEmail" placeholder="请输入邮箱"></el-input>
          </el-form-item>
          <el-form-item label="备注:" prop="userRemark">
            <el-input type="textarea" v-model="editMemberForm.userRemark" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item style="display: flex;justify-content: center;">
            <el-button @click="editMemberDialog = false">取消</el-button>
            <el-button type="primary" @click="submitEditMember">保存</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <!-- 确认信息弹窗 -->
    <el-dialog
      title="审核状态"
      :visible.sync="confirmFormDialog"
      width="951px"
    >
      <div :class="suClass">
        <el-steps
          :active="stepAcitveIndex"
          align-center
          finish-status="success"
        >
          <el-step
            v-for="(step, index) in steps"
            :key="index"
            :title="step.title"
            :status="getStatus(index)"
            :process-status="
              step.title == '审核成功' || step.title == '审核失败'
                ? 'success'
                : 'process'
            "
          >
          </el-step>
        </el-steps>
      </div>
      <div style="text-align: center;margin-top: 20px;margin-bottom: 20px;">
        {{ sutitle }}
      </div>
      <div style="margin-top: 20px;margin-bottom: 20px;font-size: 20px;">
        审核信息:
      </div>
      <div
        style="background-color: #f2f2f2;padding: 20px;box-sizing: border-box;"
      >
        <h2 style="margin-bottom: 30px;">企业基本信息:</h2>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="display: flex; margin-right: 100px;width: 400px;">
            <div style="width: 80px;">企业名称:</div>
            <span style="margin-left: 20px;">{{ formInline.companyName }}</span>
          </div>
          <div style="width: 400px;display: flex;">
            <div style="width: 80px;">法定代表人:</div>
            <span style="margin-left: 20px;">{{ formInline.nameLegal }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 400px;display: flex;">
            <div style="width: 80px;">成立时间:</div>
            <span style="margin-left: 20px;">{{ formInline.createTime }}</span>
          </div>
          <div style="width: 400px;display: flex;">
            <div style="width: 80px;">注册资本:</div>
            <span style="margin-left: 20px;">{{
              formInline.registerFunds
            }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 400px;display: flex;">
            <div style="width: 80px;">企业类型:</div>
            <span style="margin-left: 20px;">{{
              comtype(formInline.companyType)
            }}</span>
          </div>
          <div style="width: 400px;display: flex;">
            <div style="width: 130px;">统一社会信用代码:</div>
            <span style="margin-left: 20px;">{{ formInline.companyCard }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;display: flex;">
            <div style="width: 60px;">注册地址:</div>
            <span style="margin-left: 40px;width: 620px;">{{
              formInline.registerAddress
            }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;display: flex;">
            <div style="width: 60px;">办公地址:</div>
            <span style="margin-left: 40px;width: 620px;">{{
              formInline.companyAddress
            }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 400px;display: flex;">
            <div style="width: 80px;">联系人:</div>
            <span style="margin-left: 20px;">{{
              formInline.companyContacts
            }}</span>
          </div>
          <div style="width: 400px;display: flex;">
            <div style="width: 80px;">联系电话:</div>
            <span style="margin-left: 20px;">{{
              formInline.companyContactsPhone
            }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 400px;display: flex;">
            <div style="width: 80px;">电子邮箱:</div>
            <span style="margin-left: 20px;">{{
              formInline.companyContactsMail
            }}</span>
          </div>
          <div style="width: 400px;display: flex;">
            <div style="width: 80px;">公司网站:</div>
            <span style="margin-left: 20px;">{{ formInline.companyUrl }}</span>
          </div>
        </div>
        <h2 style="margin-top: 35px;margin-bottom: 30px;">企业简介:</h2>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 950px;display: flex;">
            <div style="width: 100px;">服务类别:</div>
            <span style="margin-left: 20px;">{{
              servety(formInline.serveType)
            }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 950px;display: flex;">
            <div style="width: 100px;">产品/服务优势:</div>
            <span style="margin-left: 20px;width: 640px;">{{
              formInline.serveRemark
            }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 950px;display: flex;">
            <div style="width: 100px;">目标客户群体:</div>
            <span style="margin-left: 20px;">{{
              formInline.targetRemark
            }}</span>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 950px;display: flex;">
            <div style="width: 100px;">定价策略:</div>
            <span style="margin-left: 20px;width: 640px;">{{
              formInline.pricingRemark
            }}</span>
          </div>
        </div>
        <h2 style="margin-top: 35px;margin-bottom: 30px;">附件:</h2>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;width: 950px;display: flex;">
            <div style="width: 100px;">营业执照:</div>
            <div>
              <div class="yyzzImg" style="position: relative;">
                <div
                  style="    position: absolute;
    left: 58px;
    top: 62px;
    z-index: 999;
    font-size: 16px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    pointer-events: none;
    "
                ></div>
                <el-upload
                  action="#"
                  list-type="picture-card"
                  :file-list="fileListyyzz"
                  :auto-upload="false"
                >
                  <i slot="default" class="el-icon-plus"></i>
                  <div slot="file" slot-scope="{ file }">
                    <img
                      class="el-upload-list__item-thumbnail"
                      :src="file.url"
                      alt=""
                    />
                    <span class="el-upload-list__item-actions">
                      <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreviewYYZZ(file)"
                      >
                        <i class="el-icon-zoom-in"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex;margin-bottom: 20px;">
          <div style="margin-right: 100px;display: flex;">
            <div style="width: 60px;">备注:</div>
            <span style="margin-left: 40px;width: 620px;">{{
              formInline.companyRemark
            }}</span>
          </div>
        </div>
      </div>

      <div
        class="footer_btn"
        style="margin-top: 20px;display: flex;justify-content: center;"
      >
        <span
          slot="footer"
          class="dialog-footer"
          v-if="formInline.supplierStatus == 0"
        >
          <el-button @click="confirmFormDialog = false">关闭</el-button>
        </span>
        <span
          slot="footer"
          class="dialog-footer"
          v-if="formInline.supplierStatus == 2"
        >
          <el-button @click="confirmFormDialog = false">关闭</el-button>
          <el-button type="primary" @click="cancel(formInline.companyId)"
            >撤销审核</el-button
          >
        </span>
        <span
          slot="footer"
          class="dialog-footer"
          v-if="
            formInline.supplierStatus == 3 || formInline.supplierStatus == 4
          "
        >
          <el-button @click="confirmFormDialog = false">关闭</el-button>
          <el-button type="primary" @click="goback(formInline.companyId, '4')"
            >修改信息</el-button
          >
        </span>
      </div>
    </el-dialog>

    <!-- 角色创建/编辑对话框 -->
    <el-dialog 
      :title="roleDialogType === 'add' ? '新建角色' : '编辑角色'" 
      :visible.sync="roleDialogVisible" 
      width="50%"
      @close="resetRoleForm"
    >
      <el-form :model="roleForm" :rules="roleRules" ref="roleForm" label-width="100px">
        <el-form-item label="角色名称" prop="roleName">
          <el-input v-model="roleForm.roleName" placeholder="请输入角色名称"></el-input>
        </el-form-item>
        <el-form-item label="权限配置">
          <el-tree
            ref="powerTree"
            :data="powerList"
            :props="powerProps"
            show-checkbox
            node-key="powerId"
            default-expand-all
            highlight-current
            @check="handlePowerCheck"
          ></el-tree>
        </el-form-item>
        <el-form-item label="备注" prop="roleRemark">
          <el-input type="textarea" v-model="roleForm.roleRemark" placeholder="请输入备注"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="roleForm.roleStatus">
            <el-radio label="0">正常</el-radio>
            <el-radio label="1">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRoleForm">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 角色分配对话框 -->
    <el-dialog 
      :title="'角色成员管理 - ' + (currentRole ? currentRole.roleName : '')" 
      :visible.sync="assignRoleDialogVisible" 
      width="60%"
    >
      <div v-loading="roleLoading">
        <el-tabs type="border-card">
          <el-tab-pane label="添加成员">
            <el-form label-width="80px">
              <el-form-item label="选择用户">
                <el-select
                  v-model="selectedUser"
                  filterable
                  placeholder="请选择用户"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in systemCompanyUser0"
                    :key="item.userId"
                    :label="item.user.userName + '(' + item.user.userPhone + ')'"
                    :value="item.userId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitAssignRole" :disabled="!selectedUser">添加到角色</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>

          <el-tab-pane label="已分配成员">
            <div v-if="roleUsers.length === 0" style="text-align: center; padding: 20px;">
              <span>该角色暂无分配成员</span>
  </div>
            <el-table v-else :data="roleUsers" border>
              <el-table-column prop="user.userName" label="姓名">
                <template slot-scope="scope">
                  {{ getUserDisplayField(scope.row, 'userName') }}
                </template>
              </el-table-column>
              <el-table-column prop="user.userPhone" label="手机号">
                <template slot-scope="scope">
                  {{ getUserDisplayField(scope.row, 'userPhone') }}
                </template>
              </el-table-column>
              <el-table-column prop="user.userEmail" label="邮箱">
                <template slot-scope="scope">
                  {{ getUserDisplayField(scope.row, 'userEmail') }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button 
                    type="text" 
                    size="small" 
                    style="color: #F56C6C;" 
                    @click="removeUserFromRole(scope.row)"
                  >
                    移除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="assignRoleDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    
    <!-- 修改用户信息弹窗 -->
    <el-dialog
      title="修改成员信息"
      :visible.sync="editMemberDialog"
      width="40%"
    >
        <!-- ... existing code ... -->
      </el-dialog>
    </div>

    <!-- 删除部门管理对话框 -->
    </div>
</template>

<script>
import {
  getCompanyToName,
  saveShare,
  getInfo,
  getCompanyUser,
  revie,
  delSystemCompanyUser,
  updateUserStatus,
  setCompanyAuthNew,
  getSupplierInfo,
  cancelSupplierInfo,
  editSystemUser,
  getSystemUserBySystemUserId,
  getDepartmentTree,
  addDepartment,
  editDepartment,
  deleteDepartment,
  checkDepartmentHasUsers,
  getDepartmentMembers,
  addDepartmentMember,
  removeDepartmentMember,
  getAvailableOrgMembers,
  // 角色管理相关API
  getRoleList,
  getPowerList,
  addRole,
  editRole,
  deleteRole,
  getUserRoleList,
  getRoleUserList,
  addUserRole,
  deleteUserRole,
  enableOrDisableRole
} from "@/api/userMG";
export default {
  name: "organizationInfo",
  data() {
    return {
      escape: false, //switch开启
      modal: false, //switch关闭
      dialogImageUrlyyzz: "",
      fileListyyzz: [
        {
          url:
            "http://dev.zrgyhl.com:20886/zrUtil/showImg?path=AuthU/1517810019e9805cb239f9a30b.jpg"
        }
      ],
      steps: [
        { title: "信息提交" },
        { title: "平台审核" },
        { title: "审核结果" }
      ],
      sutitle:
        "我们将在收到您的申请后5-10个工作日内进行审核,并通过您提供的联系方式通知您审核结果,请耐心等待。",
      suState: "-1",
      suClass: "confirmStep",
      yyzzsl: false,
      btnactive: "1",
      stepAcitve: 2,
      stepAcitveIndex: 2,
      confirmFormDialog: false,
      companyType: 1,
      show01: "1",
      tableData: [],
      hideUpload: false,
      dialogVisibleimg: false,
      dialogImageUrl: "",
      formdata: new FormData(),
      fileList: [],
      addimg: [],
      removeimg: [],
      ruleForm: {
        csAvatar: ""
      },
      companyId: "",
      dialogVisible: false,
      disabled: false,
      zzstate: true,
      dialogShow: "",
      dialogVisible: false,
      organizationSuccessDialog: false,
      organizationSuccessDialogC: false,
      qyrzDialog: false,
      name: "",
      restaurants: [],
      ruleForm: {
        name: ""
      },
      loading: false,
      systemCompany: {},
      systemCompanyUser: {},
      systemCompanyUser0: [],
      systemCompanyUser1: [],
      systemCompanyUser3: [],
      revieCompany: {},
      company: {},
      formInline: {},
      selectedFile0: null,
      images0: null,
      editMemberDialog: false,
      editMemberForm: {
        userId: '',
        userName: '',
        userPhone: '',
        userEmail: '',
        userRemark: ''
      },
      departmentDialogType: '',
      departmentForm: {
        deptName: '',
        deptRemark: ''
      },
      departmentTree: [],
      defaultProps: {
        children: 'children',
        label: 'deptName'
      },
      deptSearchKeyword: '',
      selectedDept: null,
      departmentDialogVisible: false,
      departmentOptions: [],
      selectedParentDept: '0',
      departmentRules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      deptMembersDialogVisible: false,
      deptMembers: [],
      deptMembersLoading: false,
      addDeptMemberDialogVisible: false,
      deptMemberForm: {
        deptId: '',
        userId: ''
      },
      selectedOrgMembers: [],
      availableOrgMembers: [],
      
      // 角色管理相关数据
      roleManagementVisible: false, // 角色管理对话框显示状态
      roleDialogVisible: false, // 角色添加/编辑对话框
      roleDialogType: 'add', // 角色对话框类型：add-新增，edit-编辑
      roleTable: [], // 角色列表
      roleForm: {
        roleName: '',
        roleRemark: '',
        powerId: '', // 逗号分隔的权限ID字符串
        roleStatus: '0', // 默认启用
        companyId: null,
        createBy: null
      },
      roleRules: {
        roleName: [
          { required: true, message: '请输入角色名称', trigger: 'blur' }
        ]
      },
      roleLoading: false,
      
      // 用户角色分配相关
      assignRoleDialogVisible: false,
      selectedUser: null, // 当前选中的用户
      userRoles: [], // 当前用户拥有的角色
      availableRoles: [], // 可分配的角色
      selectedRoles: [], // 选中要分配的角色
      roleUsers: [], // 当前角色已分配的用户列表
      currentRole: null, // 当前选中的角色
      
      // 权限列表数据
      powerList: [], // 所有权限列表
      powerProps: { // 权限树属性
        label: 'powerName',
        children: 'children'
      },
    };
  },
  mounted() {
    try {
      window.localStorage.removeItem("menuData");
      
      if (this.getQueryString("phone") != null) {
        this.phone = this.getQueryString("phone");
      }
      
      // 添加安全检查，避免userData为null时的错误
      const userData = window.localStorage.getItem("userData");
      if (userData) {
        try {
          const userDataObj = JSON.parse(userData);
          if (userDataObj && userDataObj.userPhone) {
            this.name = userDataObj.userPhone;
          }
        } catch (e) {
          console.error("解析userData出错:", e);
        }
      }
      
      // 加载数据，使用try-catch包裹每个方法调用以防止一个失败影响其他
      try {
        this.loadAll();
      } catch (e) {
        console.error("loadAll执行出错:", e);
      }
      
      // 加载权限列表和角色列表
      if (this.isOrgCreator) {
        try {
          this.loadPowerList();
        } catch (e) {
          console.error("loadPowerList执行出错:", e);
        }
        
        try {
          this.loadRoleList();
        } catch (e) {
          console.error("loadRoleList执行出错:", e);
        }
      }
    } catch (e) {
      console.error("mounted钩子执行出错:", e);
    }
  },
  components: {
    },
  computed: {
    uploadDisabled: function() {
      console.log(this.ruleForm.csAvatar);
      return this.ruleForm.csAvatar != "";
    },
    filteredDepartmentTree() {
      if (!this.deptSearchKeyword) {
        return this.departmentTree;
      }
      
      const filterNodes = (nodes, keyword) => {
        return nodes.filter(node => {
          const matchesKeyword = node.deptName.toLowerCase().includes(keyword.toLowerCase());
          
          // 如果有子节点，递归过滤
          if (node.children && node.children.length) {
            const filteredChildren = filterNodes(node.children, keyword);
            // 创建新对象避免修改原始数据
            if (filteredChildren.length > 0) {
              return { ...node, children: filteredChildren };
            }
            return matchesKeyword;
          }
          
          return matchesKeyword;
        });
      };
      
      return filterNodes([...this.departmentTree], this.deptSearchKeyword);
    },
    isOrgAdmin() {
      // 判断当前用户是否为组织管理员
      return this.company && this.user && this.company.userId === this.user.userId;
    },
    // 判断当前用户是否为组织创建者
    isOrgCreator() {
      // company.userId是组织创建者ID，user.userId是当前用户ID
      return this.company && this.user && this.company.userId === this.user.userId;
    }
  },
  created() {
    if (
      localStorage.getItem("company") != "null" &&
      Boolean(localStorage.getItem("company"))
    ) {
      this.company = JSON.parse(localStorage.getItem("company"));
      this.getSupplierInfo(this.company.companyId);
      // 加载部门数据
      this.loadDepartmentTree();
    } else {
      this.company = null;
    }
    if (Boolean(localStorage.getItem("userdata"))) {
      this.user = JSON.parse(localStorage.getItem("userdata"));
      var flg = this.user.userPhone.substring(0, 3);
      var flg1 = this.user.userPhone.substring(7, 11);
      this.name = flg + "****" + flg1;
      this.getCompanyUser();
    }
  },
  methods: {
    getQueryString(name) {
      const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    },
    goback(companyId, type) {
      if (type == "4") {
        this.cancel(companyId);
        this.formInline.supplierStatus = "4";
      }
      localStorage.setItem("supplierInfo", JSON.stringify(this.formInline));
      this.$router.push({ path: '/appUP' })
    },
    cancel(companyId) {
      cancelSupplierInfo(companyId).then(res => {
        // console.log(res.data)
        // if (res.code == 200 && res.data != null) {
        //   this.formInline = res.data;
        //   this.fileListyyzz[0].url = 'http://dev.zrgyhl.com:20886/zrUtil/showImg?path=' + res.data.idCardImgFront;
        // }
        this.confirmFormDialog = false;
        this.getSupplierInfo(companyId);
      });
    },
    servety(id) {
      return id;
    },
    comtype(id) {
      if (id == "2") {
        return "有限责任公司";
      }
      if (id == "3") {
        return "股份有限公司";
      }
      if (id == "4") {
        return "个人独资公司";
      }
      if (id == "5") {
        return "合伙企业";
      }
      if (id == "6") {
        return "国有企业";
      }
      if (id == "7") {
        return "外资企业";
      }
    },
    supprenCheck(companyId) {
      this.confirmFormDialog = true;
      this.getSupplierInfo(companyId);
    },
    getSupplierInfo(companyId) {
      getSupplierInfo(companyId).then(res => {
        console.log(res.data);
        if (res.code == 200 && res.data != null) {
          this.suState = res.data.supplierStatus;
          if (res.data.supplierStatus == "0") {
            this.steps[0].title = "信息提交";
            this.steps[1].title = "平台审核";
            this.steps[2].title = "审核成功";
            this.sutitle =
              "恭喜您，审核成功，您已经成为平台的供应商，现在可以在平台上架您的产品了。";
            this.stepAcitveIndex = 3;
            this.suClass = "confirmStep";
          }

          if (res.data.supplierStatus == "2") {
            this.steps[0].title = "信息提交";
            this.steps[1].title = "平台审核";
            this.steps[2].title = "审核结果";
            this.sutitle =
              "我们将在收到您的申请后5-10个工作日内进行审核,并通过您提供的联系方式通知您审核结果,请耐心等待。";
            this.suClass = "confirmStep2";
            this.stepAcitveIndex = 2;
          }

          if (res.data.supplierStatus == "3") {
            this.steps[0].title = "信息提交";
            this.steps[1].title = "平台审核";
            this.steps[2].title = "审核失败";
            this.sutitle = "审核失败,失败原因：" + res.data.reviewRemark;
            this.stepAcitveIndex = 3;
            this.suClass = "confirmStep3";
          }

          if (res.data.supplierStatus == "4") {
            this.steps[0].title = "信息提交";
            this.steps[1].title = "平台审核";
            this.steps[2].title = "审核撤回";
            this.sutitle = "您已手动撤回审核，修改信息后可以重新提交。";
            this.suClass = "confirmStep4";
            this.stepAcitveIndex = 3;
          }

          if (res.data.supplierStatus == "5") {
            this.steps[0].title = "信息填写";
            this.steps[1].title = "平台审核";
            this.steps[2].title = "审核结果";
            this.sutitle = "请继续填写完后提交审核。";
            this.suClass = "confirmStep2";
            this.stepAcitveIndex = 1;
          }
          localStorage.setItem("supplierInfo", JSON.stringify(res.data));
          this.formInline = res.data;
          this.fileListyyzz[0].url =
            "http://dev.zrgyhl.com:20886/zrUtil/showImg?path=" +
            res.data.idCardImgFront;
        } else {
          localStorage.removeItem("supplierInfo");
        }
      });
    },
    // 营业执照示例
    handlePictureCardPreviewYYZZ(file) {
      console.log(file, "file");
      this.dialogImageUrlyyzz = file.url;
      this.yyzzsl = true;
    },
    getStatus(index) {
      if (index < this.stepAcitve) {
        return "success"; // 已完成的步骤
      } else if (index === this.stepAcitve && this.isError) {
        this.steps[2].title = "审核失败";
        return "error"; // 当前步骤且是最后一个步骤，标记为失败
      } else {
        return "wait"; // 等待完成的步骤
      }
    },
    // 触发文件选择按钮点击事件
    handleButtonSelected(index) {
      if (index == 0) {
        // 主动触发点击事件
        this.$refs.selectFiles00.dispatchEvent(new MouseEvent("click"));
      }
    },
    onFileChange0(e) {
      if (
        e.target.files[0].name.indexOf("png") > 0 ||
        e.target.files[0].name.indexOf("jpg") > 0 ||
        e.target.files[0].name.indexOf("bmp") > 0
      ) {
      } else {
        this.$message.error("失败，上传图片文件格式支持png，jpg和bmp！");
        return false;
      }
      const that = this;
      this.selectedFile0 = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = e => {
        that.images0 = e.target.result;
      };
    },
    setCompanyAuth() {
      const formData = new FormData();
      if (this.selectedFile0 == null) {
        this.$message.error("失败，请上传营业执照照片！");
      } else {
        formData.append("file0", this.selectedFile0);
        formData.append("companyName", this.ruleForm.name);
        formData.append("companyType", this.companyType);
        this.loading = true;
        setCompanyAuthNew(formData)
          .then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "成功!"
              });
              this.getInfo();
              setTimeout(() => {
                this.loading = false;
                this.qyrzDialog = false;
                this.dialogVisible = false;
                this.organizationSuccessDialogC = true;
              }, 500);
            } else {
              this.loading = false;
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          })
          .catch(() => {
            this.loading = false;
            if (this.captchaOnOff) {
              this.getCode();
            }
          });
      }
    },
    toW() {
      this.getInfo();
      location.reload();
    },
    revie(id, status) {
      this.$confirm(status == "0" ? "确认通过" : "审批拒绝", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          revie(id, status).then(res => {
            if (res.code == 200) {
              this.getInfo();
              location.reload();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消！"
          });
        });
    },

    delSystemCompanyUser(id) {
      this.$confirm("确认删除", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          delSystemCompanyUser(id).then(res => {
            if (res.code == 200) {
              this.getInfo();
              location.reload();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消！"
          });
        });
    },
    saveShare() {
      if (this.ruleForm.name == "") {
        this.$message.error("请填写要加入的企业");
        return;
      }
      getCompanyToName(this.ruleForm.name).then(res => {
        if (res.code == 200) {
          if (res.data.length != 0) {
            saveShare(this.user.userId, res.data[0].companyId).then(res => {
              if (res.code == 200) {
                this.getInfo();
                setTimeout(() => {
                  this.dialogVisible = false;
                  this.organizationSuccessDialog = true;
                }, 500);
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            // this.$message.error("该企业不存在");
            this.clickFn("qyrz2");
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getCompanyUser() {
      var companyId = "";
      if (this.company == null) {
      } else {
        companyId = this.company.companyId;
      }
      getCompanyUser(this.user.userId, companyId).then(res => {
        if (res.code === 200) {
          if (this.company == null) {
            this.systemCompanyUser = res.data.systemCompanyUser;
            this.revieCompany = res.data.revieCompany;
            this.systemCompanyUser3 = res.data.systemCompanyUser3;
            this.systemCompany = res.data.systemCompany;
          } else {
            // 正确处理企业成员数据
            this.systemCompanyUser0 = res.data.systemCompanyUser0 || [];
            this.systemCompanyUser1 = res.data.systemCompanyUser1 || [];
            console.log('成员数据加载成功：', '已加入成员', this.systemCompanyUser0.length, '待审批成员', this.systemCompanyUser1.length);
          }
        } else {
          this.$message.error(res.msg || '获取成员数据失败');
        }
      }).catch(err => {
        console.error('获取成员数据失败', err);
        this.$message.error('获取成员数据失败');
      });
    },
    getInfo() {
      getInfo().then(res1 => {
        if (res1.code == 200) {
          localStorage.setItem("userdata", JSON.stringify(res1.data.user));
          localStorage.setItem("company", JSON.stringify(res1.data.company));
          this.userName = res1.data.user.userName;
          setTimeout(() => {
            this.userAvatarImg = res1.data.user.userAvatar;
            this.formDialog = false;
          }, 100);
        }
      });
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll() {
      getCompanyToName().then(res => {
        this.restaurants = res.data;
        console.log(this.restaurants);
      });
    },
    querySearch(queryString, cb) {
      setTimeout(() => {
        var restaurants = this.restaurants;
        var results = queryString
          ? restaurants.filter(this.createFilter(queryString))
          : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      }, 500);
    },
    handleSelect(item) {
      this.companyId = item.companyId;
      console.log(item, "select");
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // 添加活动展示照片
    handleChange(file, fileList) {
      this.$refs.upload.$children[1].$el.style.display = "none";

      const isJPG =
        file.raw.type === "image/jpeg" || file.raw.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPEG PNG 格式!");
        fileList.splice(-1, 1); //移除错误文件
        return false;
      }
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
        fileList.splice(-1, 1);
        return false;
      }
      this.addimg = fileList[0].raw;
      this.ruleForm.csAvatar = this.addimg;
    },
    // 删除活动展示照片
    handleRemove(file, fileList) {
      this.$refs.upload.$children[1].$el.style.display = "";
      console.log(fileList);
      this.ruleForm.csAvatar = "";
      this.formdata = new FormData();
    },
    // 活动展示照片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleimg = true;
    },
    // 渲染编辑获取id
    apply() {
      this.fileList = [{ url: "" }]; //这里是踩坑的点，必须写
      this.fileList[0].url = res.data.csAvatar; //这里是调用接口获取到的值 res.data.csAvatar，赋值就可以回显了
      //this.fileList[0].url 做的是单张图片回显，多张图片回显可以去掉[0]
    },
    togglezzFn(type) {
      if (type == "qy") {
        this.zzstate = true;
        this.companyType = 1;
      } else {
        this.zzstate = false;
        this.companyType = 2;
      }
    },
    clickFn(type) {
      if (type == "jrzz") {
        this.dialogVisible = true;
        this.companyId = "";
        this.ruleForm.name = "";
        this.dialogShow = "jrzz";
      } else if (type == "qyrz") {
        // 先检查用户是否已登录，如果未登录则先提示登录
        if (!localStorage.getItem('logintoken')) {
          this.$message.warning('请先登录系统');
          this.$router.push('/login');
          return;
        }
        
        // 跳转到用户认证初始页面而不是当前页面
        this.$router.push('/auth/qualification-certification');
      } else {
        this.dialogVisible = true;
        this.companyId = "";
        this.dialogShow = "qyrz";
      }
    },
    submitForm() {
      if (
        this.ruleForm.name == null ||
        this.ruleForm.name == "" ||
        this.ruleForm.name == NaN ||
        this.ruleForm.name == undefined
      ) {
        this.$message.error("该企业名称不能为空");
      } else {
        getCompanyToName(this.ruleForm.name).then(res => {
          if (res.data.length == 0) {
            this.qyrzDialog = true;
            this.dialogVisible = false;
          } else {
            this.$message.error("该企业名称已经存在");
          }
        });
      }
    },
    // 处理成员操作命令
    handleCommand(command, row) {
      switch(command) {
        case 'edit':
          this.editMember(row);
          break;
        case 'delete':
          this.deleteMember(row);
          break;
        case 'disable':
          this.toggleMemberStatus(row, '1'); // 禁用状态为1
          break;
        case 'enable':
          this.toggleMemberStatus(row, '0'); // 启用状态为0
          break;
      }
    },
    
    // 修改成员信息
    editMember(row) {
      this.editMemberForm = {
        userId: row.userId,
        userName: row.user.userName,
        userPhone: row.user.userPhone,
        userEmail: row.user.userEmail || '',
        userRemark: row.user.userRemark || ''
      };
      this.editMemberDialog = true;
    },
    
    // 提交修改成员信息
    submitEditMember() {
      this.$refs.editMemberForm.validate((valid) => {
        if (valid) {
          // 电话号码格式验证
          const phoneRegex = /^1[3-9]\d{9}$/;
          if (!phoneRegex.test(this.editMemberForm.userPhone)) {
            this.$message.error('请输入正确的手机号码');
            return;
          }
          
          // 邮箱格式验证（如果有值）
          if (this.editMemberForm.userEmail) {
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (!emailRegex.test(this.editMemberForm.userEmail)) {
              this.$message.error('请输入正确的邮箱格式');
              return;
            }
          }
          
          // 先获取当前用户完整信息
          this.$confirm('确认修改该成员信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 获取用户详细信息
            return getSystemUserBySystemUserId(this.editMemberForm.userId);
          }).then(userRes => {
            if (userRes.code == 200 && userRes.data) {
              // 保留原有数据，只修改允许编辑的字段
              const userData = userRes.data;
              const params = {
                userId: this.editMemberForm.userId,
                userName: this.editMemberForm.userName,
                userPhone: this.editMemberForm.userPhone,
                userEmail: this.editMemberForm.userEmail,
                userRemark: this.editMemberForm.userRemark,
                // 保留原有必填字段
                userPassword: userData.userPassword,
                userStatus: userData.userStatus,
                delFlag: userData.delFlag
              };
              
              return editSystemUser(params);
            } else {
              this.$message.error('获取用户信息失败');
              return Promise.reject();
            }
          }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '修改成功!'
              });
              this.editMemberDialog = false;
              this.getCompanyUser(); // 刷新列表
            } else {
              this.$message.error(res.msg || '修改失败');
            }
          }).catch(err => {
            if (err) console.error(err);
            // 用户取消操作不需要提示
          });
        } else {
          return false;
        }
      });
    },
    
    // 删除成员
    deleteMember(row) {
      this.$confirm("确认要删除该成员吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        delSystemCompanyUser(row.id).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getCompanyUser();
          } else {
            this.$message.error(res.msg || "删除失败");
          }
        });
      }).catch(() => {
        this.$message.info("已取消删除");
      });
    },
    
    // 启用/禁用成员
    toggleMemberStatus(row, status) {
      const statusText = status === '0' ? '启用' : '禁用';
      this.$confirm(`确认要${statusText}该成员吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 调用后端API修改用户状态
        this.updateUserStatus(row.userId, status).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: `${statusText}成功!`
            });
            this.getCompanyUser();
          } else {
            this.$message.error(res.msg || `${statusText}失败`);
          }
        });
      }).catch(() => {
        this.$message.info(`已取消${statusText}`);
      });
    },
    
    // 调用后端更新用户状态API
    updateUserStatus(userId, status) {
      return updateUserStatus(userId, status);
    },
    openDepartmentDialog() {
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      this.departmentDialogType = 'add';
      this.departmentForm = {
        deptName: '',
        deptRemark: '',
        companyId: this.company.companyId,
        deptParent: '0' // 顶级部门
      };
      this.selectedParentDept = '0';
      this.departmentDialogVisible = true;
      
      // 准备部门选择器数据
      this.prepareDepartmentOptions();
    },
    submitDepartment() {
      this.$refs.departmentForm.validate(valid => {
        if (!valid) {
          return false;
        }
        
        // 设置父部门ID
        if (this.departmentDialogType !== 'edit') {
          this.departmentForm.deptParent = this.selectedParentDept || '0';
        }
        
        const submitMethod = this.departmentDialogType === 'edit' ? editDepartment : addDepartment;
        
        submitMethod(this.departmentForm).then(res => {
          if (res.code === 200) {
            this.$message.success(
              this.departmentDialogType === 'edit' ? '编辑成功' : '添加成功'
            );
            this.departmentDialogVisible = false;
            // 刷新部门树
            this.loadDepartmentTree();
          } else {
            this.$message.error(res.msg || (this.departmentDialogType === 'edit' ? '编辑失败' : '添加失败'));
          }
        }).catch(err => {
          console.error(this.departmentDialogType === 'edit' ? '编辑部门失败' : '添加部门失败', err);
          this.$message.error(this.departmentDialogType === 'edit' ? '编辑部门失败' : '添加部门失败');
        });
      });
    },
    addSubDepartment(data) {
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      this.departmentDialogType = 'addSub';
      this.departmentForm = {
        deptName: '',
        deptRemark: '',
        companyId: this.company.companyId,
        deptParent: data.deptId
      };
      this.selectedParentDept = data.deptId;
      this.departmentDialogVisible = true;
      
      // 准备部门选择器数据
      this.prepareDepartmentOptions();
    },
    editDepartment(data) {
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      this.departmentDialogType = 'edit';
      this.departmentForm = {
        deptId: data.deptId,
        deptName: data.deptName,
        deptRemark: data.deptRemark || '',
        companyId: data.companyId,
        deptParent: data.deptParent
      };
      this.departmentDialogVisible = true;
    },
    removeDepartment(node, data) {
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      // 先检查是否有子部门
      if (data.children && data.children.length > 0) {
        this.$message.warning('该部门下有子部门，不能删除，请先删除子部门');
        return;
      }
      
      // 再检查是否有用户
      checkDepartmentHasUsers(data.deptId).then(checkRes => {
        if (checkRes.code === 200) {
          if (checkRes.data === true) {
            this.$message.warning('该部门下有用户，不能删除');
            return;
          }
          
          // 二次确认
          this.$confirm('确定要删除该部门吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            deleteDepartment(data.deptId).then(res => {
              if (res.code === 200) {
                this.$message.success('删除成功');
                // 刷新部门树
                this.loadDepartmentTree();
                // 清空选中部门
                this.selectedDept = null;
              } else {
                this.$message.error(res.msg || '删除失败');
              }
            }).catch(err => {
              console.error('删除部门失败', err);
              this.$message.error('删除部门失败');
            });
          }).catch(() => {
            this.$message.info('已取消删除');
          });
        } else {
          this.$message.error(checkRes.msg || '检查部门用户失败');
        }
      }).catch(err => {
        console.error('检查部门用户失败', err);
        this.$message.error('检查部门用户失败');
      });
    },
    // 加载部门树结构
    loadDepartmentTree() {
      if (this.company && this.company.companyId) {
        getDepartmentTree(this.company.companyId).then(res => {
          if (res.code === 200) {
            this.departmentTree = res.data || [];
            this.filteredDepartmentTree = [...this.departmentTree];
          } else {
            this.$message.error(res.msg || '获取部门数据失败');
          }
        }).catch(err => {
          console.error('获取部门数据失败', err);
          this.$message.error('获取部门数据失败');
        });
      }
    },
    prepareDepartmentOptions() {
      // 转换部门数据为级联选择器可用的格式
      const formatDeptOptions = (depts) => {
        return depts.map(dept => {
          const option = {
            deptId: dept.deptId,
            deptName: dept.deptName,
            value: dept.deptId,
            label: dept.deptName
          };
          
          if (dept.children && dept.children.length > 0) {
            option.children = formatDeptOptions(dept.children);
          }
          
          return option;
        });
      };
      
      // 添加顶级选项
      this.departmentOptions = [{
        deptId: '0',
        deptName: '顶级部门',
        value: '0',
        label: '顶级部门'
      }].concat(formatDeptOptions(this.departmentTree));
    },
    refreshDeptTree() {
      this.loadDepartmentTree();
      this.$message.success('部门数据已刷新');
    },
    handleNodeClick(data) {
      this.selectedDept = data;
    },
    getParentDeptName(parentId) {
      if (parentId === '0') {
        return '顶级部门';
      }
      
      // 平铺部门树，找到父部门名称
      const flattenDepts = (depts) => {
        let result = [];
        depts.forEach(dept => {
          result.push(dept);
          if (dept.children && dept.children.length) {
            result = result.concat(flattenDepts(dept.children));
          }
        });
        return result;
      };
      
      const allDepts = flattenDepts(this.departmentTree);
      const parentDept = allDepts.find(dept => dept.deptId === parentId);
      
      return parentDept ? parentDept.deptName : '未知部门';
    },
    manageDepartmentMembers(data) {
      this.selectedDept = data;
      this.deptMembersDialogVisible = true;
      this.loadDeptMembers(data.deptId);
    },
    loadDeptMembers(deptId) {
      this.deptMembersLoading = true;
      
      getDepartmentMembers(deptId).then(res => {
        if (res.code === 200) {
          this.deptMembers = res.rows || [];
          // 确保每个成员都有user属性
          this.deptMembers.forEach(member => {
            if (!member.user) {
              member.user = {}; // 创建空user对象避免前端报错
            }
          });
        } else {
          this.$message.error(res.msg || '获取部门成员失败');
        }
        this.deptMembersLoading = false;
      }).catch(err => {
        console.error('获取部门成员失败', err);
        this.$message.error('获取部门成员失败');
        this.deptMembersLoading = false;
      });
    },
    addMemberToDept() {
      // 检查是否有管理员权限
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      // 加载可用的组织成员
      this.loadAvailableOrgMembers();
      this.addDeptMemberDialogVisible = true;
    },
    loadAvailableOrgMembers() {
      // 添加加载状态
      this.availableOrgMembers = [];
      this.$nextTick(() => {
        // 确保部门ID存在
        if (!this.selectedDept || !this.selectedDept.deptId) {
          this.$message.error('部门信息不完整');
          return;
        }
        
        getAvailableOrgMembers(this.company.companyId, this.selectedDept.deptId).then(res => {
          if (res.code === 200) {
            // 确保返回的数据中每个成员都有必要的属性
            this.availableOrgMembers = (res.data || []).filter(member => member && member.user);
            
            if (this.availableOrgMembers.length === 0) {
              this.$message.info('没有可添加的成员');
            }
          } else {
            this.$message.error(res.msg || '获取可添加成员失败');
          }
        }).catch(err => {
          console.error('获取可添加成员失败', err);
          this.$message.error('获取可添加成员失败');
        });
      });
    },
    submitAddDeptMembers() {
      if (!this.selectedOrgMembers || this.selectedOrgMembers.length === 0) {
        this.$message.warning('请选择要添加的成员');
        return;
      }
      
      // 显示加载状态
      this.deptMembersLoading = true;
      
      // 创建添加成员的请求数组
      const promises = this.selectedOrgMembers.map(userId => {
        return addDepartmentMember({
          deptId: this.selectedDept.deptId,
          userId: userId
        });
      });
      
      // 使用Promise.all等待所有请求完成
      Promise.all(promises)
        .then(responses => {
          const hasErrors = responses.some(res => res.code !== 200);
          
          if (hasErrors) {
            this.$message.warning('部分成员添加失败，请刷新后重试');
          } else {
            this.$message.success('添加成员成功');
          }
          
          // 无论成功失败，都关闭对话框并重新加载成员列表
          this.addDeptMemberDialogVisible = false;
          this.selectedOrgMembers = [];
          this.loadDeptMembers(this.selectedDept.deptId);
        })
        .catch(err => {
          console.error('添加部门成员失败', err);
          this.$message.error('添加部门成员失败');
        })
        .finally(() => {
          this.deptMembersLoading = false;
        });
    },
    removeMemberFromDept(row) {
      // 检查是否有管理员权限
      if (!this.isOrgAdmin) {
        this.$message.error('没有管理员权限');
        return;
      }
      
      this.$confirm('确认要从该部门移除该成员吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeDepartmentMember(row.id).then(() => {
          this.$message.success('移除成功');
          this.loadDeptMembers(this.selectedDept.deptId);
        }).catch(err => {
          console.error('移除成员失败', err);
          this.$message.error('移除成员失败');
        });
      }).catch(() => {
        this.$message.info('已取消');
      });
    },
    tabActive(tab) {
      console.log('切换标签', tab, '之前:', this.btnactive);
      this.btnactive = tab;
      console.log('切换标签后:', this.btnactive, '已加入成员数:', this.systemCompanyUser0.length, '待审批成员数:', this.systemCompanyUser1.length);
    },
    openRoleDialog(type, row) {
      this.roleDialogVisible = true;
      this.roleDialogType = type;
      
      // 重置选中的权限
      if (this.$refs.powerTree) {
        this.$refs.powerTree.setCheckedKeys([]);
      }
      
      if (type === 'edit') {
        // 深度复制原始数据，避免修改原始数据
        const clonedRow = JSON.parse(JSON.stringify(row));
        console.log('编辑前的原始角色数据:', clonedRow);
        
        // 构建一个仅包含必需字段的对象
        const cleanedData = {
          roleId: clonedRow.roleId,
          roleName: clonedRow.roleName,
          roleRemark: clonedRow.roleRemark || '',
          roleStatus: clonedRow.roleStatus || '0',
          companyId: clonedRow.companyId,
          powerId: clonedRow.powerId || ''
        };
        
        this.roleForm = cleanedData;
        console.log('清理后的角色数据:', this.roleForm);
        
        // 设置权限树选中状态，确保等待DOM更新后再设置
        this.$nextTick(() => {
          if (this.$refs.powerTree) {
            if (this.roleForm.powerId) {
              const powerIds = this.roleForm.powerId.split(',').filter(id => id !== '');
              console.log('设置权限选中状态，权限ID列表:', powerIds);
              this.$refs.powerTree.setCheckedKeys(powerIds);
            } else {
              console.log('没有找到权限ID，清空选中状态');
              this.$refs.powerTree.setCheckedKeys([]);
            }
          } else {
            console.warn('权限树组件未找到');
          }
        });
      } else {
        // 新增角色时，设置基本字段
        this.roleForm = {
          roleName: '',
          roleRemark: '',
          powerId: '',
          roleStatus: '0',
          companyId: this.company.companyId
        };
      }
    },
    
    submitRoleForm() {
      this.$refs.roleForm.validate(valid => {
        if (!valid) {
          return false;
        }
        
        // 获取选中的权限ID，包括父节点和子节点
        let powerIds = [];
        if (this.$refs.powerTree) {
          // 获取所有选中的节点（包括半选中的父节点）
          const checkedNodes = this.$refs.powerTree.getCheckedNodes();
          const halfCheckedNodes = this.$refs.powerTree.getHalfCheckedNodes();
          
          // 合并所有节点并提取ID
          const allNodes = [...checkedNodes, ...halfCheckedNodes];
          powerIds = allNodes.map(node => node.powerId);
          
          // 过滤掉undefined和空字符串
          powerIds = powerIds.filter(id => id);
          
          console.log('选中的权限ID数组:', powerIds);
          this.roleForm.powerId = powerIds.join(',');
        }
        
        // 准备提交的数据，只包含必要字段，不包含任何时间相关字段
        let submitData;
        if (this.roleDialogType === 'edit') {
          // 编辑模式：只包含这些特定字段，不包含任何时间字段
          submitData = {
            roleId: this.roleForm.roleId,
            roleName: this.roleForm.roleName,
            roleRemark: this.roleForm.roleRemark || '',
            roleStatus: this.roleForm.roleStatus || '0',
            companyId: this.roleForm.companyId,
            powerId: this.roleForm.powerId || ''
          };
        } else {
          // 添加模式：只包含这些特定字段，不包含任何时间字段
          submitData = {
            roleName: this.roleForm.roleName,
            roleRemark: this.roleForm.roleRemark || '',
            roleStatus: this.roleForm.roleStatus || '0',
            companyId: this.company.companyId,
            powerId: this.roleForm.powerId || ''
          };
        }
        
        console.log('最终提交的角色数据:', submitData);
        
        const submitMethod = this.roleDialogType === 'edit' ? editRole : addRole;
        
        submitMethod(submitData).then(res => {
          if (res.code === 200) {
            this.$message.success(
              this.roleDialogType === 'edit' ? '编辑成功' : '添加成功'
            );
            this.roleDialogVisible = false;
            
            // 将当前的powerId保存起来，便于刷新后更新
            const savedRoleId = submitData.roleId || res.data;
            const savedPowerId = submitData.powerId;
            
            // 刷新角色列表
            this.loadRoleList().then(() => {
              // 如果是编辑模式，确保更新列表中的权限数据
              if (this.roleDialogType === 'edit' && savedRoleId) {
                // 查找刚刚编辑的角色
                const updatedRole = this.roleTable.find(role => role.roleId === savedRoleId);
                if (updatedRole) {
                  // 更新权限数据
                  updatedRole.powerId = savedPowerId;
                  console.log('已更新角色列表中的权限数据:', updatedRole);
                }
              }
            });
          } else {
            this.$message.error(res.msg || (this.roleDialogType === 'edit' ? '编辑失败' : '添加失败'));
          }
        }).catch(err => {
          console.error(this.roleDialogType === 'edit' ? '编辑角色失败' : '添加角色失败', err);
          this.$message.error(this.roleDialogType === 'edit' ? '编辑角色失败' : '添加角色失败');
        });
      });
    },
    
    loadRoleList() {
      this.roleLoading = true;
      return getRoleList(this.company.companyId).then(res => {
        console.log('获取角色列表响应:', res);
        if (res.code === 200) {
          this.roleTable = res.data || [];
          console.log('角色列表数据:', this.roleTable);
        } else {
          this.$message.error(res.msg || '获取角色列表失败');
        }
        this.roleLoading = false;
        return Promise.resolve(res);
      }).catch(err => {
        console.error('获取角色列表失败', err);
        this.$message.error('获取角色列表失败');
        this.roleLoading = false;
        return Promise.reject(err);
      });
    },
    toggleRoleStatus(row) {
      const status = row.roleStatus === '0' ? '1' : '0';
      enableOrDisableRole(row.roleId, status).then(res => {
        if (res.code === 200) {
          this.$message.success(`角色状态已更新为${status === '0' ? '正常' : '停用'}`);
          this.loadRoleList();
        } else {
          this.$message.error('更新角色状态失败');
        }
      }).catch(err => {
        console.error('更新角色状态失败', err);
        this.$message.error('更新角色状态失败');
      });
    },
    assignRole(row) {
      this.assignRoleDialogVisible = true;
      this.currentRole = row;
      this.selectedUser = null;
      // 重置选中的用户
      
      // 加载该角色已分配的成员列表
      this.loadRoleUsers(row.roleId);
    },
    
    loadRoleUsers(roleId) {
      this.roleLoading = true;
      this.roleUsers = [];
      
      getRoleUserList(roleId).then(res => {
        if (res.code === 200) {
          this.roleUsers = res.data || [];
        } else {
          this.$message.error(res.msg || '获取角色成员列表失败');
        }
        this.roleLoading = false;
      }).catch(err => {
        console.error('获取角色成员列表失败', err);
        this.$message.error('获取角色成员列表失败');
        this.roleLoading = false;
      });
    },
    handleDeleteRole(row) {
      // 打印角色信息以帮助诊断问题
      console.log('准备删除角色:', row);
      console.log('角色ID (roleId):', row.roleId, '类型:', typeof row.roleId);
      
      // 如果roleId为空，显示错误消息
      if (!row.roleId) {
        this.$message.error('删除失败: 角色ID为空');
        return;
      }
      
      this.$confirm('确认要删除该角色吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 确保roleId是字符串类型
        const roleId = String(row.roleId);
        console.log('发送删除请求，角色ID:', roleId);
        
        // 捕获详细的错误信息
        try {
          deleteRole(roleId).then(res => {
            console.log('删除角色响应:', res);
            if (res.code === 200) {
              this.$message.success('角色删除成功');
              this.loadRoleList();
            } else {
              console.error('后端返回错误:', res.msg);
              this.$message.error(res.msg || '删除角色失败');
            }
          }).catch(err => {
            console.error('删除角色API调用失败:', err);
            this.$message.error('删除角色失败: ' + (err.message || JSON.stringify(err)));
          });
        } catch (error) {
          console.error('删除角色过程中发生异常:', error);
          this.$message.error('删除角色发生异常: ' + error.message);
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    updateRoleStatus(id, status) {
      return enableOrDisableRole(id, status);
    },
    
    // 角色管理相关方法
    resetRoleForm() {
      this.roleForm = {
        roleName: '',
        roleRemark: '',
        powerId: '',
        roleStatus: '0',
        companyId: this.company ? this.company.companyId : null,
        createBy: this.user ? this.user.userId : null
      };
      if (this.$refs.powerTree) {
        this.$refs.powerTree.setCheckedKeys([]);
      }
    },
    
    handlePowerCheck() {
      // 获取选中的权限ID，并以逗号分隔
      const checkedKeys = this.$refs.powerTree.getCheckedKeys();
      this.roleForm.powerId = checkedKeys.join(',');
    },
    
    loadPowerList() {
      getPowerList().then(res => {
        if (res.code === 200) {
          this.powerList = res.data || [];
        } else {
          this.$message.error(res.msg || '获取权限列表失败');
        }
      }).catch(err => {
        console.error('获取权限列表失败', err);
        this.$message.error('获取权限列表失败');
      });
    },
    
    submitAssignRole() {
      if (!this.selectedUser) {
        this.$message.warning('请选择用户');
        return;
      }
      
      if (!this.currentRole || !this.currentRole.roleId) {
        this.$message.warning('角色信息不完整');
        return;
      }
      
      // 显示加载状态
      this.roleLoading = true;
      
      // 创建用户角色请求
      const params = {
        userId: this.selectedUser,
        roleId: this.currentRole.roleId
      };
      
      addUserRole(params).then(res => {
        if (res.code === 200) {
          this.$message.success('分配角色成功');
          // 重新加载角色成员列表
          this.loadRoleUsers(this.currentRole.roleId);
          // 重置选择
          this.selectedUser = null;
        } else {
          this.$message.error(res.msg || '分配角色失败');
        }
        this.roleLoading = false;
      }).catch(err => {
        console.error('分配角色失败', err);
        this.$message.error('分配角色失败');
        this.roleLoading = false;
      });
    },
    
    removeUserFromRole(row) {
      if (!row || !row.id) {
        this.$message.error('用户角色信息不完整');
        return;
      }
      
      this.$confirm('确定要移除此用户的角色吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteUserRole(row.id).then(res => {
          if (res.code === 200) {
            this.$message.success('移除成功');
            // 重新加载角色成员列表
            this.loadRoleUsers(this.currentRole.roleId);
          } else {
            this.$message.error(res.msg || '移除失败');
          }
        }).catch(err => {
          console.error('移除用户角色失败', err);
          this.$message.error('移除用户角色失败');
        });
      }).catch(() => {
        this.$message.info('已取消操作');
      });
    },
    // 获取用户在表格中显示的字段
    getUserDisplayField(item, field) {
      if (!item) return '未知';
      
      // 如果item有user对象，优先从user对象获取
      if (item.user && item.user[field]) {
        return item.user[field];
      }
      
      // 直接从item尝试获取
      if (item[field]) {
        return item[field];
      }
      
      // 尝试从其他可能的字段名获取
      const fieldMappings = {
        userName: ['name', 'username'],
        userPhone: ['phone', 'mobile', 'phoneNumber'],
        userEmail: ['email', 'mail']
      };
      
      if (fieldMappings[field]) {
        for (const altField of fieldMappings[field]) {
          // 先检查user对象
          if (item.user && item.user[altField]) {
            return item.user[altField];
          }
          // 再检查item本身
          if (item[altField]) {
            return item[altField];
          }
        }
      }
      
      return '未知';
    },
    getUserLabel(item) {
      if (!item) return '未知用户';
      
      // 首先尝试通过user对象获取信息
      if (item.user && item.user.userName) {
        return `${item.user.userName}(${item.user.userPhone || '无手机号'})`;
      } 
      
      // 然后尝试直接从item获取
      if (item.userName || item.name) {
        const userName = item.userName || item.name;
        const userPhone = item.userPhone || item.phone || '无手机号';
        return `${userName}(${userPhone})`;
      } 
      
      // 最后尝试使用user id作为标识
      if (item.userId || item.id) {
        return `用户ID: ${item.userId || item.id}`;
      }
      
      // 如果什么都没有，返回未知
      return '未知用户';
    },
    removeTimeFields(obj) {
      // 创建一个新对象来存储过滤后的数据
      const filteredObj = { ...obj };
      
      // 定义要删除的时间相关字段和其他不需要的字段
      const fieldsToDel = [
        // 时间字段
        'createTime', 'updateTime', 'createDate', 'updateDate',
        'createBy', 'updateBy', 'createTimeStr', 'updateTimeStr',
        'createdAt', 'updatedAt', 'dateCreated', 'lastUpdated',
        'gmtCreate', 'gmtModified', 'registerTime', 'timestamp',
        
        // 其他可能导致问题的字段
        'children', 'deleted', 'delFlag', 'version', 'revision',
        'tenant', 'tenantId', 'statusDesc'
      ];
      
      // 删除所有不需要的字段
      fieldsToDel.forEach(field => {
        if (field in filteredObj) {
          delete filteredObj[field];
        }
      });
      
      return filteredObj;
    },
  }
};
</script>

<style scoped>
.page {
  width: 100%;
  color: #000000;
}
.box{
  width: 100%;
  margin: auto;
}
.mainCard3 >>> .el-table__cell {
  border: 0px;
}
.bottomStep >>> .is-process {
  color: #b7b9be;
}

.confirmStep2 >>> .is-success {
  color: #f59c28;
}

.confirmStep2 >>> .el-step__head.is-success {
  border-color: #f59c28;
}

.confirmStep2 >>> .el-step__head.is-wait {
  color: #ccc;
  border-color: #ccc;
}

.confirmStep2 >>> .el-step__title.is-wait {
  color: #ccc;
}

.confirmStep4 >>> .is-success {
  color: #f59c28;
}

.confirmStep4 >>> .el-step__head.is-success {
  border-color: #f59c28;
}

.confirmStep4 >>> .el-step__head.is-wait {
  color: #ccc;
  border-color: #ccc;
}

.confirmStep4 >>> .el-step__title.is-wait {
  color: #ccc;
}

.confirmStep3 >>> .is-success {
  color: #f59c28;
}

.confirmStep3 >>> .el-step__head.is-success {
  border-color: #f59c28;
}

.confirmStep3 >>> .el-step__head.is-wait {
  color: #d9001b;
  border-color: #d9001b;
}

.confirmStep3 >>> .el-step__title.is-wait {
  color: #d9001b;
}

.el-step__head.is-success {
  color: #67c23a;
  border-color: #67c23a;
}

.confirmStep >>> .el-step__head.is-wait {
  color: rgb(3, 182, 21);
  border-color: rgb(3, 182, 21);
}

.confirmStep >>> .el-step__title.is-wait {
  color: rgb(3, 182, 21);
}

.bottomStep >>> .el-step__head.is-process {
  border-color: #b7b9be;
}

.el-upload-list__item-thumbnail {
  width: 148px;
  height: 148px;
}

.confirmStep >>> .is-success {
  color: #f59c28;
}

.confirmStep >>> .el-step__head.is-success {
  border-color: #f59c28;
}
.confirmStep >>> .el-step__line {
  background-color: #fff;
}
.confirmStep2 >>> .el-step__line {
  background-color: #fff;
}
.confirmStep3 >>> .el-step__line {
  background-color: #fff;
}
.confirmStep4 >>> .el-step__line {
  background-color: #fff;
}
.organizationBox {
  box-sizing: border-box;
}

.organizationBox1 {
  box-sizing: border-box;
}

.mainCard {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
  padding: 20px 50px;
  height: 300px;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.mainCard1 {
  width: 100%;
  padding: 20px 50px;
  height: 350px;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.mainCard2 {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 50px;
  height: 200px;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.mainCard3 {
  width: 100%;
  padding: 20px 50px;
  height: 460px;
  overflow: hidden;
  background-color: #fff;
  border-radius: 5px;
  box-sizing: border-box;
}

.mainCardRight > img {
  width: 500px;
  height: 250px;
}

.el-dialog__wrapper >>> .el-dialog__title {
  font-weight: 700;
}

.organizationTop {
  background-color: #f7f8fa;
  height: 35px;
  border-radius: 5px;
  line-height: 35px;
  padding-left: 15px;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 30px;
  color: black;
}

.organizationTop1 {
  height: 35px;
  border-radius: 5px;
  line-height: 35px;
  padding-left: 15px;
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 30px;
  color: black;
}

.organizationSub {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.shu {
  width: 4px;
  height: 15px;
  background-color: #0068ff;
  margin-right: 4px;
}

.shuText {
  font-weight: bold;
  color: black;
  font-size: 15px;
}

.organizationName {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.sqrName {
  color: black;
}

.sqrIphone {
  color: black;
  font-size: 16px;
}

.demo-ruleForm >>> .el-form-item__label {
  text-align: left;
}

.demo-ruleForm >>> .el-form-item__content {
  margin-left: 0px;
}

.zzmcbox >>> .el-form-item__content {
  margin-left: 0 !important;
}

.zzmcbox {
  margin-bottom: 30px;
}

/* .el-dialog__wrapper >>>  */
.el-dialog--center .el-dialog__body {
  padding-bottom: 0;
}

.zzTypeBox {
  display: flex;
  width: 130px;
  align-items: center;
  height: 50px;
  border: 1px solid #efeff1;
  margin-right: 10px;
  padding-left: 15px;
  cursor: pointer;
}

.zzactive {
  border: 1px solid #136fee;
  color: #136fee;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.hide .el-upload--picture-card {
  display: none;
}

.mengcengDiv {
  width: 148px;
  height: 148px;
  position: absolute;
  right: 65px;
  display: inline-block;
  /* 或者 block，取决于你的布局需求 */
}

.mengcengDiv img {
  display: block;
  /* 如果需要图片以块状显示 */
  width: 100%;
  /* 可选，根据需要调整图片大小 */
  height: 100%;
}

.mengcengDiv:after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(24, 24, 24, 0.7);
  /* 灰色蒙板，最后一个参数是透明度 */
  z-index: 1;
  /* 确保蒙板在图片之上 */
}

.mainCardTopBox {
  width: 100%;
  height: 200px;
  align-items: center;
}

.mainCardTopBox {
  display: flex;
  justify-content: space-between;
}

.bottomStep >>> .is-finish {
  color: #f59c28;
}

.bottomStep >>> .el-step__head.is-finish {
  border-color: #f59c28;
}

.confirmStep >>> .el-steps:nth-child(3) > .el-step__head.is-finish {
  border-color: #f59c28;
}

.b .buttonB {
  width: 100px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #797979;
  cursor: pointer;
  margin-right: 10px;
}

.buttonc {
  width: 100px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid#f6a63d;
  cursor: pointer;
  margin-right: 10px;
  color: #f6a63d;
}

.btnactive {
  color: #fff;
  background-color: #f59a23;
  border: 0px solid #797979;
}

.yyzzImg {
  .el-upload--picture-card {
    display: none;
  }

  .el-upload-list__item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 1;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
  }
}

/* 部门树样式 */
.custom-tree-node {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.el-tree-node__content {
  height: 36px;
}

.el-tree-node__content:hover {
  background-color: #f5f7fa;
}

.el-tree {
  background: transparent;
}

.mengcengDiv {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/views/auth/userAuth.vue